import clientLeal from "./client-leal.png";
import clientExigente from "./client-exigente.png";
import clientindeciso from "./client-indeciso.png";
import clienttimido from "./client-timido.png";
import clientimpaciente from "./clinet-impaciente.png";
import clientsociable from "./client-sociable.png";
import clientpasivo from "./client-pasivo.png";
import clientnegociador from "./clinet-negociador.png";

import headexigente from "./head-exigentev1.svg";
import headtimido from "./head-timidov1.svg";
import headindeciso from "./head-indesisov1.svg";
import headleal from "./head-lealv1.svg";
import headPaciente from "./head-impacientev1.svg";
import headSociable from "./head-sociablev1.svg";
import headPasivo from "./head-pasivov1.svg";
import headNEgociador from "./head-negociador.svg";

import torsoTerco from "./torso-terco.svg";
import torsoQuejoso from "./torso-quejoso.svg";
import torsoEnojon from "./torso-enojon.svg";
import torsoApurado from "./torso-apurado.svg";
import torsoGrosero from "./torso-grosero.svg";
import torsoMayor from "./torso-mayor.svg";
import torsoNino from "./torso-nino.svg";
import torsoAlcholizado from "./torso-alcholizado.svg";
import torsoIndeciso from "./torso-indeciso.svg";

export const imgClients = {
	clientLeal,
	clientExigente,
	clientindeciso,
	clienttimido,
	clientimpaciente,
	clientsociable,
	clientpasivo,
	clientnegociador,
	headexigente,
	headtimido,
	headindeciso,
	headPaciente,
	headSociable,
	headPasivo,
	headNEgociador,
	headleal,
	torsoTerco,
	torsoQuejoso,
	torsoEnojon,
	torsoApurado,
	torsoGrosero,
	torsoMayor,
	torsoNino,
	torsoAlcholizado,
	torsoIndeciso,
};
